// extracted by mini-css-extract-plugin
export default {"wrapper":"CompositeNavConfig_wrapper__5QNzz"};